import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItineraryService {

  private _itineraryapiUrl = `${environment.travel}/quotes`;
  private _travelapiUrl = `${environment.travel}`;
  private _inventoryapiUrl = `${environment.inventory}`;

  constructor(
    private _http: HttpClient
  ) { }

  // Add itinerary details
  addItineraryDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/additinerarydetails`, formData);
  }

  // Add accommodation details
  addAccommodationDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addaccommodation`, formData);
  }

  // Add transportation details
  addTransportationDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addtransportation`, formData);
  }

  // Add route craft data
  addRouteCraft(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addroutecraft`, formData)
  }

  // Add cost and pricing
  addCostAndPricing(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addcostandpricing`, formData);
  }

  // Add inclusoins and exclusions data
  addInclusionsAndExclusions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addinclusionandexclusion`, formData)
  }

  // Add Terms and conditions data
  addTermsAndConditions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addtermsandcondition`, formData)
  }

  // Add payment Terms and conditions data
  addPaymentTermsAndConditions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addpaymenttermsandcondition`, formData)
  }

  // Add Cancellation policy data
  addCancellaionPolicy(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addcancellationpolicy`, formData)
  }

  // Add Important info data
  addImportantInformation(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addimportantinformation`, formData)
  }

  // Add notes data
  addnotes(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addnotes`, formData)
  }

  // Add hotel pricing data
  addHotelPricing(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addhotelpricing`, formData)
  }

  // Add transportation of flight information
  addTransportationFlights(formData: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/addflighttransportation`, formData)
  }

  addTrainTransportationDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addtrain`, formData)
  }

  addBusTransportationDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/addbus`, formData)
  }

  addCarTransportationDetails(formData:any): Observable<any>{
    return this._http.post<any>(`${this._itineraryapiUrl}/addcar`, formData)
  }

  addFerryTransportationDetails(formData:any): Observable<any>{
    return this._http.post<any>(`${this._itineraryapiUrl}/addferry`, formData)
  }

  addCruiseTransportationDetails(formData:any): Observable<any>{
    return this._http.post<any>(`${this._itineraryapiUrl}/addcruise`, formData)
  }

  updateQuoteFlightDetails(formData: any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updateflighttransportation`, formData)
  }

  cloneQuoteForNewLead(leadId: string, quoteId: string): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/clonequote/${leadId}/${quoteId}`, {});
  }

  deleteFlightImage(id:any, uniqueNumber:any): Observable<any>{
    return this._http.delete<any>(`${this._travelapiUrl}/flight/deleteattachment/${id}/${uniqueNumber}`);
  }

  // get all ltinerary for a lead
  getAllItinerarysForLead(id: any, pageNumber: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${environment.travel}/quotesoflead/${id}`, paginationSettings);
  }

  // Get quote data
  getQuoteData(id: any): Observable<any> {
    return this._http.get<any>(`${this._itineraryapiUrl}/quote/${id}`)
  }

  // Get all quotes
  getAllQuotes(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._itineraryapiUrl}`, paginationSettings);
  }

  getAllQuotesWithFilters(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._itineraryapiUrl}/filter`, paginationSettings);
  }

  // Update quote itineray
  updateQuote(id: any, formData: any): Observable<any> {
    return this._http.put<any>(`${this._itineraryapiUrl}/quote/${id}`, formData);
  }

  // Delte quote itinery
  deleteQuote(id: any): Observable<any> {
    return this._http.delete<any>(`${this._itineraryapiUrl}/quote/${id}`);
  }

  // Get quote in form of template design (HTML rendering)
  getQuoteTemplateHtml(quoteId: any): Observable<any> {
    return this._http.get<any>(`${this._inventoryapiUrl}/quotetemplate/${quoteId}`, { responseType: 'text' as 'json' })
  }

  updateQuoteTemplateDetails(quoteId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._inventoryapiUrl}/templates/${quoteId}`, formData);
  }

  updateQuoteTemplate(quoteId:any, templateId:any): Observable<any> {
    return this._http.put<any>(`${this._inventoryapiUrl}/changetemplate/${quoteId}/${templateId}`, {});
  }

  // Save as default inventory itinerary
  saveAsInventoryItinerary(quoteId: any): Observable<any> {
    return this._http.post<any>(`${this._itineraryapiUrl}/${quoteId}`, {});
  }

  selectRecommendedItinerary(type: any, itineraryDetails: any): Observable<any> {
    return this._http.post<any>(`${this._travelapiUrl}/recommendedQuote/${type}`, itineraryDetails);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updatequotes`, req)
  }

  
  uploadRouteCraftDocument(formData:any): Observable<any>{
    return this._http.post<any>(`${environment.travel}/AIRouteDetailsExtract`, formData);
  }  
}
